import { AccountType } from '@/Types/Enums/accountType';
import { HelpPageConfiguration } from '@/Types/helpPageConfiguration';
import { HelpPageInfo } from '@/Types/helpPageInfo';

export class HelpPageProvider {
  // Pages that have different help pages for different account types
  private static readonly dualHelpPageConfiguration: HelpPageConfiguration = {
    'Home': {
      [AccountType.Business]: '52601.htm',
      [AccountType.Partner]: '52601.htm'
    },
    'Requests': {
      [AccountType.Business]: '52601.htm',
      [AccountType.Partner]: '52601.htm'
    },
    'RequestDetails': {
      [AccountType.Business]: '52603.htm',
      [AccountType.Partner]: '61554.htm'
    },
    'Users': {
      [AccountType.Business]: '57804.htm',
      [AccountType.Partner]: '57804.htm'
    },
    'AddUser': {
      [AccountType.Business]: '57809.htm',
      [AccountType.Partner]: '57809.htm'
    },
    'Groups': {
      [AccountType.Business]: '57806.htm',
      [AccountType.Partner]: '57806.htm'
    },
    'AddGroup': {
      [AccountType.Business]: '57817.htm',
      [AccountType.Partner]: '57817.htm'
    },
    'MyAccount': {
      [AccountType.Business]: '52772.htm',
      [AccountType.Partner]: '52772.htm'
    }
  };

  // Pages that have a single help page reference regardless of account type
  private static readonly singleHelpPageConfiguration: Record<string, string> = {
    'UploadFolders': '61542.htm',
    'UploadFolderDetails': '61545.htm',
    'Cameras': '52604.htm',
    'AddCamera': '52605.htm',
    'EditCamera': '52639.htm',
    'PortalError': '52601.htm'
  };

  private static readonly folderMapping = {
    [AccountType.Business]: 'NICE%20Investigate%20Community%20(Business)',
    [AccountType.Partner]: 'NICE%20Investigate%20Community%20(BusinessPartner)'
  };

  public static getHelpPageInfo(pageType: string, accountType: AccountType): HelpPageInfo | null {
    // First check if it's in the dual configuration
    const dualConfig = this.dualHelpPageConfiguration[pageType];
    if (dualConfig) {
      const helpId = dualConfig[accountType];
      if (!helpId) {
        return null;
      }
      return {
        helpId,
        accountType
      };
    }

    // Then check if it's in the single configuration
    const singleHelpId = this.singleHelpPageConfiguration[pageType];
    if (singleHelpId) {
      return {
        helpId: singleHelpId,
        accountType
      };
    }

    // Page type not found in either configuration
    return null;
  }

  public static buildHelpUrl(helpPageInfo: HelpPageInfo): string {
    const folder = this.folderMapping[helpPageInfo.accountType];
    return `/help/Content/NICE%20Investigate%20Help/${folder}/${helpPageInfo.helpId}`;
  }

  public static getHelpUrl(pageType: string, accountType: AccountType): string | null {
    const helpPageInfo = this.getHelpPageInfo(pageType, accountType);
    if (!helpPageInfo) {
      return null;
    }

    return this.buildHelpUrl(helpPageInfo);
  }
}